import { TranslocoService } from '@jsverse/transloco';
import { Localization } from '../models';

export function configure(
  translocoService: TranslocoService,
  localizations: Localization[][],
  localStorageLanguageKey = 'assist-lang'
) {
  const availableLangs: any[] = translocoService.getAvailableLangs();
  const langFromLocalStorage = localStorage.getItem(localStorageLanguageKey);
  if (langFromLocalStorage !== null) {
    const found = availableLangs.find((x) => x === langFromLocalStorage);
    const activeLang = found ? found : translocoService.getDefaultLang();
    const translation = localizations[0].find((x) => x.language == activeLang);
    translocoService.setActiveLang(activeLang);
    translation.valueGetter().then((x) => {
      translocoService.setTranslation(x, translation.language, {
        merge: false,
      });
    });
  } else {
    const found = availableLangs.find((x) => x === navigator.language.slice(0, 2));
    const activeLang = found ? found : translocoService.getDefaultLang();
    const translation = localizations[0].find((x) => x.language == activeLang);
    translocoService.setActiveLang(activeLang);
    translation.valueGetter().then((x) => {
      translocoService.setTranslation(x, translation.language, {
        merge: false,
      });
    });
  }
}
